import './index.scss'
import data from './data.json'
import classNames from 'classnames'
import {useSelector} from 'react-redux'

const Footer = () => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const getCurrentYear = () => {
        return new Date().getFullYear()
    }
    const linkBuilder = url => {
        return process.env.REACT_APP_SITE_URL + url
    }
    const generateFooterMenu = () => {
        return (
            <ul>
                {data.menu.map((item, index) => (
                    <li key={index}><a target="_blank" href={linkBuilder(item.url)}>{item.name}</a></li>
                ))}
            </ul>
        )
    }
    return (
        <footer className={classNames('footer', {
            dark: isDarkMode
        })}>
            {generateFooterMenu()}
            <p>© {getCurrentYear()} Pinghome</p>
        </footer>
    )
}

export default Footer
